import { defineMessages } from 'react-intl'

export const translationsHome = defineMessages({
  homeTitle: {
    id: 'home.title',
    defaultMessage: 'Home',
  },
})
